module.exports = __webpack_public_path__ + "themes/mf/img/prize-9.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-9.png
// module id = 102
// module chunks = 3